import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

import { apiPath } from '../config/apiBase';
const API = apiPath('/api/users/directory');

function authHeaders() {
  const token = localStorage.getItem('token');
  return { withCredentials: true, headers: { Authorization: `Bearer ${token}` } };
}

export default function UserPicker({
  value,
  onSelect,
  staffOnly = true,
  requestorsOnly = false,
  eligibleForTeam = null,
  placeholder = 'Search users…',
  autoFocus = false,
}) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!autoFocus) return undefined;
    const t = setTimeout(() => {
      inputRef.current?.focus();
      setOpen(true);
    }, 50);
    return () => clearTimeout(t);
  }, [autoFocus]);

  useEffect(() => {
    const t = setTimeout(() => {
      setLoading(true);
      const params = new URLSearchParams();
      if (q) params.set('q', q);
      if (requestorsOnly) params.set('requestors_only', 'true');
      else if (staffOnly) params.set('staff_only', 'true');
      if (eligibleForTeam) params.set('eligible_for_team', eligibleForTeam);
      axios.get(`${API}?${params}`, authHeaders())
        .then((res) => setResults(Array.isArray(res.data) ? res.data : []))
        .catch(() => setResults([]))
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [q, staffOnly, requestorsOnly, eligibleForTeam]);

  const selected = results.find((u) => u.user_id === value);

  return (
    <div style={{ position: 'relative' }}>
      <input
        ref={inputRef}
        value={selected ? `${selected.name} (${selected.email})` : q}
        onChange={(e) => { setQ(e.target.value); setOpen(true); if (selected) onSelect(null); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        style={{ width: '100%', padding: '6px 8px', borderRadius: '8px', border: '1px solid #D1D5DB' }}
      />
      {loading && <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>Searching…</div>}
      {open && !selected && results.length > 0 && (
        <ul style={{ position: 'absolute', zIndex: 80, background: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', width: '100%', maxHeight: '200px', overflowY: 'auto', margin: '4px 0 0', padding: 0, listStyle: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
          {results.map((u) => (
            <li key={u.user_id}>
              <button
                type="button"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => { onSelect(u); setQ(''); setOpen(false); }}
                style={{ display: 'block', width: '100%', textAlign: 'left', padding: '6px 8px', border: 'none', background: 'white', cursor: 'pointer', fontSize: '12px' }}
              >
                <strong>{u.name}</strong>
                <span style={{ color: '#6B7280' }}> — {u.email}</span>
                {u.designation && <span style={{ color: '#9CA3AF', fontSize: '12px' }}> · {u.designation}</span>}
                {u.other_products?.length > 0 && (
                  <span style={{ display: 'block', color: '#B45309', fontSize: '12px', marginTop: '2px' }}>
                    Also on: {u.other_products.join(', ')}
                  </span>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
      {open && !selected && !loading && results.length === 0 && (
        <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>
          {q ? 'No users found' : 'No users available'}
        </div>
      )}
    </div>
  );
}
